import React from 'react'
import { IssuingSpendingProfile } from './issuingSpendingProfile'

export const IssuingSpendingProfileList = () => {
  return (
    <IssuingSpendingProfile />
  )
}
